import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from '../utils/constants';

const getSignedUrl = async (apiPath) => {
  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data.url;
};

export const getFloorplanDownloadUrl = async (projectId, floorplanId) =>
  getSignedUrl(`projects/${projectId}/floorplans/${floorplanId}/signed-url`);

/**
 * A signed URL to the original PDF the floorplan's image was made from
 * (`floorplan.source`); the request fails (404) for a floorplan without one.
 */
export const getFloorplanSourceUrl = async (projectId, floorplanId) =>
  getSignedUrl(
    `projects/${projectId}/floorplans/${floorplanId}/source-signed-url`
  );
